angular
	.module 'App.Repository'
	.factory 'CurrencyRepository', ['BaseRepository', (BaseRepository) ->
		class CurrencyRepository extends BaseRepository
			@resource = '/currencies'
			@isRestricted = true

		return new CurrencyRepository
	]



